import { useQuery } from '@tanstack/react-query';
import { ScenarioScope } from '../scope';
import { CashflowReadiness } from '../types';

// How much recorded data a new model would be seeded from. Read once per
// visit: the profile changes rarely while the adviser sits on the models tab.
export function useCashflowReadiness(scope: ScenarioScope | null) {
  const { data, isLoading, isError } = useQuery<CashflowReadiness>({
    queryKey: [scope?.kind === 'family' ? 'families' : 'clients', scope?.id, 'cashflow-readiness'],
    enabled: Boolean(scope),
    staleTime: 60_000,
    refetchOnWindowFocus: false,
  });
  return { readiness: data ?? null, isLoading, isError };
}
